import React, { Component } from 'react';
import { dashboardActions, userActions, alertActions, hospitalActions } from '../../_actions';
import { connect } from 'react-redux';
import LoadingOverlay from 'react-loading-overlay';
import moment from 'moment';
import jsPDF from "jspdf";
import "jspdf-autotable";
import EditNoteIcon from '@mui/icons-material/EditNote';
import Box from '@mui/material/Box';
import Rating from '@mui/material/Rating';
import { List, ListItem, ListItemText, Paper, Typography, Container } from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';

import ReactPaginate from 'react-paginate';
import { isMobile } from "react-device-detect";

// import Chart from 'react-apexcharts'
import Marquee from 'react-fast-marquee';
import HospitalSidebar from '../../components/HospitalSidebar/HospitalSidebar';
import AddTreatementModel from './components/AddTreatementModel';
class HospitalTreatment extends Component {

  constructor(props) {
    super(props);
    this.state = {
      offset: 0,
      pageNo: 1,
      size: 10,
      priceTempData: {
        BPC: 1,
        btcPrice: 0,
        dollerPrice: 0,
      },
      fieldslogin: {},
      errorslogin: {},
      option: {},
      fieldsUser: {},
      open: false

    }
  }

  componentDidMount() {
    let data = {
      "keyWord": "",
      "pageNo": 1,
      "size": 10
    }
    let dataCmc = {
      "keyWord": "",
      "pageNo": 1,
      "size": 12
    }
    let data2 = {
      "keyWord": "",
      "pageNo": 1,
      "size": 5
    }

    this.props.dispatch(hospitalActions.getTreatmentList(data));
    this.props.dispatch(hospitalActions.getHospitalProfile(data));
    window.scrollTo(0, 0)


  }

  static getDerivedStateFromProps(nextProps, prevState) {

    if (nextProps.users.sendCoinSuccess) {
      return {
        ...nextProps,
        fieldslogin: {},
        errorslogin: {}
      }
    } else {
      return {
        ...nextProps
      }
    }
  }

  sendCoin = (e) => {
    e.preventDefault();
    if (this.handleValidationSendCoin()) {

      let { coinType, toAddress, recievingAmount, password } = this.state.fieldslogin;
      this.props.dispatch(userActions.sendCoin({
        password: password,
        coinType: coinType,
        amount: Number(recievingAmount),
        to: toAddress,
      }, this.props));
    }
  }
  handleValidationSendCoin = () => {
    let fieldslogin = this.state.fieldslogin;
    let errorslogin = {};
    let formIsValid = true;

    //coinType
    if (!fieldslogin["coinType"]) {
      formIsValid = false;
      errorslogin["coinType"] = "Please select Coin Type!";
    }
    //toAddress
    if (!fieldslogin["toAddress"]) {
      formIsValid = false;
      errorslogin["toAddress"] = "Please Enter To Address";
    }
    //amount
    if (!fieldslogin["amount"]) {
      formIsValid = false;
      errorslogin["amount"] = "Please enter Amount!";
    }
    //fees
    if (!fieldslogin["fees"]) {
      formIsValid = false;
      errorslogin["fees"] = "Please enter Fees!";
    }
    //password
    if (!fieldslogin["password"]) {
      formIsValid = false;
      errorslogin["password"] = "Please enter Password!";
    }
    //recievingAmount
    if (!fieldslogin["recievingAmount"]) {
      formIsValid = false;
      errorslogin["recievingAmount"] = "Please enter RecievingAmount!";
    }

    this.setState({ errorslogin: errorslogin });
    return formIsValid;
  }

  inputChangeAmount = (event) => {
    event.preventDefault();
    let { users } = this.props;
    let { overview } = users;
    let { setting } = overview;
    let { txFee } = setting ? setting : {};
    // console.log("event.target.value  ", event.target.value);
    if (event.target.value >= 0) {
      const { fieldslogin, errorslogin } = this.state;
      fieldslogin[event.target.name] = event.target.value;
      fieldslogin['amount'] = event.target.value;
      fieldslogin['fees'] = txFee ? txFee : 0.0001;
      fieldslogin['recievingAmount'] = parseFloat(event.target.value - (txFee ? txFee : 0.0001)).toFixed(8);
      errorslogin['amount'] = "";
      this.setState({ fieldslogin, errorslogin });
    } else {
      const { errorslogin } = this.state;
      errorslogin['amount'] = "Amount should be positive number.";
      this.setState({ errorslogin });
    }
  }

  copyCodeToClipboard = (data) => {
    navigator.clipboard.writeText(data)
    this.props.dispatch(alertActions.success("Copied!"));
  }

  handlePageChange = (offset, page) => {
    // console.log(offset, page)
  }

  inputChangePrice = (event) => {
    let { users } = this.props;
    let { priceDeta } = users;
    let { btcPrice, dollerPrice } = priceDeta ? priceDeta : {}
    event.preventDefault();
    const { priceTempData } = this.state;
    priceTempData[event.target.name] = event.target.value;
    priceTempData['dollerPrice'] = parseFloat(event.target.value * dollerPrice).toFixed(8);
    priceTempData['btcPrice'] = parseFloat(event.target.value * btcPrice).toFixed(8);
    this.setState({ priceTempData });
    // BPC: 1,
    //     btcPrice: 0,
    //     dollerPrice: 0,
  }
  handlePageClick = (data) => {
    let offset = Math.ceil(data.selected * this.state.size);
    this.setState({ offset: offset, page: data.selected });
    let datatemp = {
      "keyWord": this.state.keyWord,
      "pageNo": data.selected + 1,
      "size": this.state.size
    }
    console.log("datatempdatatempdatatempdatatempdatatemp", datatemp)
    this.props.dispatch(hospitalActions.getTreatmentList(datatemp));
    // this.props.dispatch(hospitalActions.getHospitalDrList(datatemp));
  }

  handleSearch = (event) => {
    event.preventDefault();
    let { value } = event.target;
    this.setState({ keyWord: value, offset: 0 });
    let data = {
      "txType": "SEND_RECEIVED",
      "keyWord": value,
      "pageNo": 1,
      "size": this.state.size
    }
    this.props.dispatch(userActions.getTx(data));
  }

  exportPDF = () => {
    let { users } = this.props;

    let { txList } = users;
    const unit = "pt";
    const size = "A4"; // Use A1, A2, A3 or A4
    const orientation = "portrait"; // portrait or landscape

    const marginLeft = 40;
    const doc = new jsPDF(orientation, unit, size);

    doc.setFontSize(15);

    const title = "Send and Received Report";
    const headers = [["DATE", "TRANSACTION TYPE", "AMOUNT", "COIN", "TRANSACTION STATUS"]];
    const data = txList.map(elt => [moment(new Date(parseInt(elt.createdAt))).utcOffset("+05:30").format("YYYY-MM-DD HH:mm"), elt.txType, elt.amount, elt.coin, elt.status ? "SUCESS" : "PENDING"]);

    let content = {
      startY: 50,
      head: headers,
      body: data
    };

    doc.text(title, marginLeft, 40);
    doc.autoTable(content);
    doc.save(Date.now() + "_send_received_report.pdf")
  }

  onClickMenu = (url) => {
    this.props.history.push(url)
  }



  handleValidationUserInfo = () => {
    let fieldsUser = this.state.fieldsUser;
    let errorslogin = {};
    let formIsValid = true;

    // name
    if (!fieldsUser["name"]) {
      formIsValid = false;
      errorslogin["name"] = "Invalid Name!";
    }

    // title
    if (!fieldsUser["title"]) {
      formIsValid = false;
      errorslogin["title"] = "Invalid Title!";
    }

    // mobNo
    if (!fieldsUser["mobNo"]) {
      formIsValid = false;
      errorslogin["mobNo"] = "Invalid Mobile Number!";
    }

    // alternateNo
    if (!fieldsUser["alternateNo"]) {
      formIsValid = false;
      errorslogin["alternateNo"] = "Invalid Alternate Number!";
    }

    // profileImg
    if (!fieldsUser["profileImg"]) {
      formIsValid = false;
      errorslogin["profileImg"] = "Invalid Profile Image URL!";
    }

    // aboutUs
    if (!fieldsUser["aboutUs"]) {
      formIsValid = false;
      errorslogin["aboutUs"] = "Invalid About Us!";
    }

    this.setState({ errorslogin: errorslogin });
    return formIsValid;
  };






  inputChange = (e) => {
    e.preventDefault();
    let { name, value } = e.target;
    // this.setState({ [name]: value });
    let fieldsUser = this.state.fieldsUser;
    let errorslogin = this.state.errorslogin;
    fieldsUser[name] = value;
    errorslogin[name] = "";
    // console.log(name, value);
    this.setState({ fieldsUser, errorslogin });

  }


  addTreatment = (e) => {
    console.log(this.state.fieldsUser)
    if (this.handleValidationUserInfo()) {
      let data = {
        name: this.state.fieldsUser.name,//oldPassword
        title: this.state.fieldsUser.title,
        mobNo: this.state.fieldsUser.mobNo,//newpassword
        alternateNo: this.state.fieldsUser.alternateNo,
        profileImg: this.state.fieldsUser.profileImg,
        specializationId: this.state.fieldsUser.specializationId,
        aboutUs: this.state.fieldsUser.aboutUs,
        address: this.state.fieldsUser.address,
        rating: this.state.fieldsUser.rating,
        reviewRatings: this.state.fieldsUser.reviewRatings,
        gmap: this.state.fieldsUser.gmap,
        specializationId: []
      }
      console.log("updatePasswordSubmit___updatePasswordSubmit:::", data);
      this.props.dispatch(hospitalActions.addTreatment(data, this.props));
      this.setState({
        fieldsUser: {
          name: "",
          title: "",
          mobNo: "",
          alternateNo: "",
          profileImg: "",
          specializationId: "",
          aboutUs: "",
        },
        errorslogin: {}, // Optionally, you can reset errors as well
      });
    }


  }




  openAddTreatmentModel = () => {

    this.setState((prevState) => ({
      open: !prevState.open,
    }));
    console.log(this.state.open)
  }


  deleteTreatment = (id) => {


    let { dashboard, hospital } = this.props;
    let { loading, userData } = dashboard;
    let { hospitalTreatmentList } = userData ? userData : {}

    let finalDaat = hospitalTreatmentList.filter((element) => (element.id != id)).map((element)=>element.id)


    this.props.dispatch(hospitalActions.addHospitalTreatment({ "treatmentList": finalDaat }))


  }


  render() {

    let { dashboard, hospital } = this.props;
    let { loading, userData } = dashboard;
    let { hospitalTreatmentList } = userData ? userData : {}
    console.log(hospitalTreatmentList)
    let { TreatementList } = hospital;
    let { list, total } = TreatementList ? TreatementList : {};
    // let { list, total } = TreatementList?.dashboards?.getTreatmentList;
    console.log("RENDER_________teamLastLevel::", list, total);
    // console.log("RENDER_________maintenancemessage::", maintenancemessage);

    return (
      <div className=' overflow-scroll   h-[93vh] flex'>
        <AddTreatementModel open={this.state.open} toggle={this.openAddTreatmentModel} />
        <HospitalSidebar />
        <LoadingOverlay
          active={loading}
          className="temp001"
          spinner
          text='Please wait...' />
        <section className=' flex p-3 flex-col w-full h-scren overflow-y-auto'>


          <div className=' flex justify-end items-end'>
            <button onClick={this.openAddTreatmentModel} className='bg-[#005F60] font-bold p-3 rounded-md text-white'>Add Treatment</button>
          </div>

          {/* Treatement List */}

          <Container>
            {hospitalTreatmentList && hospitalTreatmentList?.length > 0 &&

              <Paper elevation={3} style={{ margin: '20px', padding: '20px' }}>
<Typography className='bg-[#005F60] text-white p-2 rounded-lg' variant="h5">Treatment List</Typography>
                <List>
                  {hospitalTreatmentList?.map((e) => (
                    <ListItem className=' border-b-2 border-gray-200 border-t-2' key={e.id}>
                      <ListItemText className=' text-lg p-2' primary={e?.name} />
                      <Box sx={{ display: 'flex', gap: 2 }}>
                        {/* <EditNoteIcon className=' cursor-pointer'/>  */}
<button type='Delete'>

                        <DeleteIcon className='text-[#005F60] cursor-pointer' onClick={()=>this.deleteTreatment(e.id)} />
</button>
                      </Box>
                    </ListItem>
                  ))}
                </List>
              </Paper>
            }
          </Container>


          {
            isMobile ?
              <nav className="relative z-0 flex justify-end mt-5 w-76">
                {
                  total && total > 10 ?
                    <ReactPaginate
                      previousLabel={'Prev'}
                      nextLabel={'Next'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={total / this.state.size}
                      marginPagesDisplayed={0}
                      pageRangeDisplayed={2}
                      onPageChange={this.handlePageClick}
                      containerClassName={'pagination'}
                      pageClassName={'page-cls'}
                      activeClassName={'active'}
                    />
                    : null}
              </nav> : <nav className="relative z-0 flex justify-end mt-5 w-76">
                {
                  total && total > 10 ?
                    <ReactPaginate
                      previousLabel={'Previous'}
                      nextLabel={'Next'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={total / this.state.size}
                      marginPagesDisplayed={3}
                      pageRangeDisplayed={3}
                      onPageChange={this.handlePageClick}
                      containerClassName={'pagination'}
                      pageClassName={'page-cls'}
                      activeClassName={'active'}
                    />
                    : null}
              </nav>
          }

        </section>



      </div>
    );
  }

}

function mapStateToProps(state) {
  const { users, dashboard, hospital } = state;
  const { overview } = users ? users : {};
  const { setting, user, wallet } = overview ? overview : {};
  // console.log("mapStateToProps______________dashboard::", dashboard);
  return {
    users,
    setting,
    user,
    dashboard,
    wallet,
    hospital
  };
}
export default connect(mapStateToProps)(HospitalTreatment);